import serverSide from './server-side';
import initialMount from './client';
const preset = [serverSide, initialMount];
export default preset;
